export const SPECIAL_HEADERS = {
  CALLER_ID_KEY: 'x-caller-id',
  CALLER_ID_VALUE: 'hotwater::widget',
};
